<template>
  <div>
  <gmap-map
    :center="position"
    :zoom="17"
    :options="{styles: styles,gestureHandling: 'cooperative',mapTypeControl:false,streetViewControl:false}"
    ref="mapVenue"
    class="map-location-canvas"
  >
    <gmap-marker
      :position="position"
      :clickable="false"
      :draggable="false"
      :icon="this.icon"
    ></gmap-marker>
    <gmap-marker
      :position="userPos"
      :clickable="false"
      :draggable="false"
      v-if="userLoc"
    ></gmap-marker>
  </gmap-map>
     <section>
      <div class="row">
        <div class="col-xs-12">
          <p class="bold margin-top-2 margin-bottom-2">{{getTranslation('get-directions-from-where-you-are')}}</p>
        </div>
        <div class="col-xs">
          <button class="cta-inline" v-if="!showSteps" @click="showDirections('WALKING')">{{getTranslation('by-foot')}}</button>
          
        </div>
        <div class="col-xs">
          <button class="cta-inline" v-if="!showSteps" @click="showDirections('DRIVING')">{{getTranslation('by-car')}}</button>
        </div>
      </div>
    
      <div ref="mapDetails" class="map-directions"></div>
      <button class="cta" v-if="showSteps" @click="hideDirections">{{getTranslation('hide-directions')}}</button>
    </section>
  </div>

</template>

<script>
  import mixinLanguages from '../mixins/Language'
  export default {
    name:'mapVenue',
    props: ['position'],
    mixins: [mixinLanguages],
    mounted() {
        console.log('mounted map');
        if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(function(position){
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                console.log('loaded');
                this.userPos = pos;
                this.venuePos = pos;
                this.userLoc = true;
            }.bind(this));
        }
        this.appLanguage = this.language;
    },
    computed: {
      // position() {
      //   console.log('value changed');
      // }
    },
    watch: {
      userLoc() {
          
      },
    },
    methods: {
      showDirections(travelMode) {
        // this.showSteps = !this.showSteps;
        this.showSteps = true;
        // if (this.showSteps == true) {
          const bounds = new google.maps.LatLngBounds();
          bounds.extend(this.position);
          bounds.extend(this.userPos);
          this.$refs.mapVenue.$mapObject.fitBounds(bounds);
          this.userLoc = true;
          this.getRoute(travelMode);
        // }
      },
      hideDirections() {
          this.showSteps = false;
          this.$refs.mapVenue.$mapObject.setZoom(14);
          this.$refs.mapVenue.$mapObject.setCenter(this.position);
          this.$refs.mapDetails.innerHTML = "";
      },
      getRoute (mode) {
            console.log('get route');
            this.directionsService = new google.maps.DirectionsService();
            this.directionsDisplay = new google.maps.DirectionsRenderer();
            this.directionsDisplay.setMap(this.$refs.mapVenue.$mapObject);
            this.directionsDisplay.setPanel(this.$refs.mapDetails);
            var vm = this
            vm.directionsService.route({
              origin: this.userPos,
              destination: this.position,
              travelMode: mode
            }, function (response, status) {
              if (status === 'OK') {
                vm.directionsDisplay.setDirections(response);

              } else {
                console.log('Directions request failed due to ' + status)
              }
            })
          }
    },
    data () {
      return {
        data:[],
        // icon: {url:'https://digital.rigabiennial.com/static/map-marker.png'},
        icon: {url:'/static/icon-triangle.svg',scaledSize: new google.maps.Size(15, 15),anchor: new google.maps.Point(0, 15)},
        markers:[],
        userPos:{},
        showSteps:false,
        userLoc:false,
        center: {lat: this.position.lat ,lng:this.position.lng},
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"saturation":"-100"},{"lightness":"57"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"lightness":"1"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.bus","elementType":"labels.text.fill","stylers":[{"saturation":"0"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"transit.station.bus","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"weight":"1"},{"lightness":"0"}]},{"featureType":"transit.station.rail","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.rail","elementType":"labels.text.fill","stylers":[{"gamma":"1"},{"lightness":"40"}]},{"featureType":"transit.station.rail","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#d2d2d2"},{"visibility":"on"}]}]
      }
    },
  }
</script>

<style media="screen">

  .map-location-canvas {
    width: 100%;
    height: 400px;
    margin-top: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/MapVenue.vue